 

export const  API_URL ={
// API_BASE_URL:"http://localhost:3000",
// API_BASE_URL:"https://apiallso.creato.live",
API_BASE_URL:"https://api.allsomart.in",
}